import { useMutation } from '@apollo/client';
import type { DeleteControlsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteControlsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteControlsTRPC } from './useDeleteControlsTRPC';

export const useDeleteControls = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation
  const [deleteControlsGraphQL, graphqlState] = useMutation(
    DeleteControlsDocument,
    {
      update: (cache) => {
        evictField(cache, 'control');
        evictField(cache, 'linked_item');
        evictField(cache, 'control_aggregate');
      },
    }
  );

  // tRPC mutation
  const trpcMutation = useDeleteControlsTRPC();

  const deleteControls = async (
    ids: string[]
  ): Promise<DeleteControlsMutation> => {
    if (trpcEnabled) {
      return trpcMutation.deleteControls(ids);
    }

    const result = await deleteControlsGraphQL({
      variables: { Ids: ids },
    });
    if (!result.data) {
      throw new Error('Failed to delete controls');
    }

    return result.data;
  };

  if (trpcEnabled) {
    return {
      deleteControls,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteControls,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
